import { JSDOM } from "jsdom";
import { limitSlotElements } from "./limitSlotElements";

describe("limitSlotElements", () => {
    it("should remove slots that are not in the allowed list and keep those that are allowed", () => {
        const dom = new JSDOM(`<!DOCTYPE html><body>Hello world</body>`);
        const host = dom.window.document.createElement("div");
        host.attachShadow({ mode: "open" });
        host.shadowRoot.innerHTML = `<slot name="banana"></slot><slot name="apple"></slot>`;
        dom.window.document.body.appendChild(host);
        const allowed = {
            banana: ["div", "span"],
            apple: ["h1"]
        };

        const legalSlot = dom.window.document.createElement("div");
        legalSlot.setAttribute("slot", "banana");
        const illegalSlot = dom.window.document.createElement("p");
        illegalSlot.setAttribute("slot", "apple");

        host.appendChild(legalSlot);
        host.appendChild(illegalSlot);

        limitSlotElements(host, { allowed });

        expect(host.querySelectorAll("[slot='banana']")).toHaveLength(1);
        expect(host.querySelectorAll("[slot='apple']")).toHaveLength(0);
    });

    it("should remove elements that are in the disallowed list and keep those that are allowed", () => {
        const dom = new JSDOM(`<!DOCTYPE html><body>Hello world</body>`);
        const host = dom.window.document.createElement("div");
        host.attachShadow({ mode: "open" });
        host.shadowRoot.innerHTML = `<slot name="banana"></slot><slot name="apple"></slot>`;
        dom.window.document.body.appendChild(host);
        const disallowed = {
            banana: ["div", "span"],
            apple: ["h1"]
        };

        const legalSlot = dom.window.document.createElement("button");
        legalSlot.setAttribute("slot", "banana");
        const illegalSlot = dom.window.document.createElement("h1");
        illegalSlot.setAttribute("slot", "apple");

        host.appendChild(legalSlot);
        host.appendChild(illegalSlot);

        limitSlotElements(host, { disallowed });

        expect(host.querySelectorAll("[slot='banana']")).toHaveLength(1);
        expect(host.querySelectorAll("[slot='apple']")).toHaveLength(0);
    });
});
